import { Component, OnInit, ViewContainerRef, Inject } from '@angular/core';
import { transition, animate, style, trigger } from '@angular/animations';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem } from '../../setup-equipment/setup-equipment.model';
import { GETSetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { SetupImplementService } from '../setup-implement.service';
import { GenericIdName, SetupImplementErrorCodes, SaveImplementDetailParams, ImplementDetails } from '../setup-implement.model';
import { ImplementToCopy } from './copy-implement-dialog.model';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'app-copy-implement-dialog',
    templateUrl: './copy-implement-dialog.component.html',
    styleUrls: ['./copy-implement-dialog.component.scss'],
    animations: [
        trigger(
            'fadeInOut', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('500ms', style({ opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ opacity: 0 }),
                    animate('0ms', style({ opacity: 0 }))
                ])
            ]
        )],
    providers: [MatDialog]
})

export class CopyImplementDialogComponent implements OnInit {

    displayedColumns = [
        'selectImplement', 'implementTypeAndSerial', 'newSerialNo',
        'setupDate', 'implementHoursAtSetup', 'equipmentSMUAtSetup', 'status'];
    dataSource = new MatTableDataSource<ImplementToCopy>();

    // User selected parameters
    destEquipment: number = 0;
    destJobsite: number = 0;

    equipmentOrInventory: number = 1;
    customerList: CustomerSelectItem[] = [];
    jobsiteList: JobsiteSelectItem[] = [];
    equipmentList: EquipmentSelectItem[] = [];
    implementList: GenericIdName[] = [];

    // User selections in input boxes
    selectedCustomer: number;
    selectedJobsite: number;
    selectedEquipment: number;
    isCopy: boolean = false;
    // Error codes
    pageErrors: SetupImplementErrorCodes = new SetupImplementErrorCodes();

    constructor(public dialogRef: MatDialogRef<CopyImplementDialogComponent>,
        private _equipmentService: GETSetupEquipmentService,
        private _implementService: SetupImplementService,
        public toastr: NotificationsService, vcr: ViewContainerRef, private _router: Router,

        @Inject(MAT_DIALOG_DATA) public data: any) {
        
    }

    ngOnInit() {
        if (this._router.url == '/setup/implement') {

            if (this.data != null) {
                if (this.data.jobsiteId != null) {
                    this.destJobsite = this.data.jobsiteId;
                }
                if (this.data.equipmentId != null) {
                    this.destEquipment = this.data.equipmentId;
                }
                if (this.data.jobsiteId == null || this.data.equipmentId == null) {
                    this.dialogRef.close();
                }
            } else {
                this.dialogRef.close();
            }
        }
        else {
            this.isCopy = true;
        }
        this._equipmentService.getCustomerList().subscribe(r => {
            this.customerList = r;
        })

    }

    // Show the list of Jobsites for the selected customer.
    loadJobsitesForCustomer() {
        if (this.selectedCustomer == null)
            return;
        this.selectedJobsite = null;
        this.jobsiteList = [];
        this.selectedEquipment = null;
        this.equipmentList = [];
        this._equipmentService.getJobsiteList(this.selectedCustomer).subscribe(r => {
            this.jobsiteList = r;
        });
    }

    // If the implement is selected as being on an equipment, 
    // show the list of equipment for that jobsite.
    loadEquipmentForJobsite() {
        if (this.selectedJobsite == null)
            return;
        this._equipmentService.getEquipmentList(this.selectedJobsite).subscribe(r => {
            this.equipmentList = r;
        });
    }

    // Load implements for the selected equipment.
    onSelectEquipment() {
        if (this.selectedEquipment != null) {
            this.loadImplementsForEquipment();
        }
    }

    // Implement is in inventory.
    createInInventory() {
        // Only proceed if the jobsite is selected.
        if (this.selectedJobsite == null) {
            return;
        }

        this._implementService.GetImplementsInInventory(this.selectedJobsite).subscribe(r => {
            this.implementList = r;
            this.loadTableOfImplementsForCopy();
        });
    }

    // Gets the list of implements that are currently loaded on the selected equipment.
    loadImplementsForEquipment() {
        this._implementService.GetImplementsOnEquipment(this.selectedEquipment).subscribe(r => {
            this.implementList = r;
            this.loadTableOfImplementsForCopy();
        });
    }

    // Load the table of implements available to be copied.
    loadTableOfImplementsForCopy() {
        var newList: ImplementToCopy[] = [];
        for (var i = 0; i < this.implementList.length; i++) {
            var newImplement: ImplementToCopy = {
                selectImplement: false,
                implementId: this.implementList[i].Id,
                implementTypeAndSerial: this.implementList[i].Name,
                newSerialNo: "",
                setupDate: null,
                implementHoursAtSetup: 0,
                equipmentSMUAtSetup: 0,
                status: 0,
                budget_hours:0,
                Purchased_Cost:0
            }
            newList.push(newImplement);
        }
        this.dataSource.data = newList;
    }

    // Exit modal by pressing Cancel
    onCloseClick() {
        this.dialogRef.close({ data: {} });
    }

    validateNewSerialNo(newSerialNo: string) {
        if (newSerialNo == null || newSerialNo.trim().length == 0) {
            return false;
        }
        return true;
    }

    validateSetupDate(setupDate: string) {
        if (setupDate == null) {
            return false;
        }
        return true;
    }

    validateImplementHoursAtSetup(implementSetupHours) {
        if (implementSetupHours == null || (implementSetupHours === "") || isNaN(implementSetupHours) || implementSetupHours < 0) {
            return false;
        }
        return true;
    }

    validateEquipmentSMU(smu) {
        if (smu == null || (smu == "") || isNaN(smu) || smu < 0) {
            return false;
        }
        return true;
    }

    // Exit modal by pressing Accept
    onConfirmClick() {
        for (var i = 0; i < this.dataSource.data.length; i++) {
            var implement = this.dataSource.data[i];
            if (implement.selectImplement) {
                var isNewSerialNoEntered = this.validateNewSerialNo(implement.newSerialNo);
                var isSetupDateEntered = this.validateSetupDate(implement.setupDate);
                var isImplementSetupHoursEntered = this.validateImplementHoursAtSetup(implement.implementHoursAtSetup);

                if (!isNewSerialNoEntered) {
                    this.toastr.error("Please enter the serial number.");
                    break;
                }

                if (!isSetupDateEntered) {
                    this.toastr.error("Please enter the setup date.");
                    break;
                }

                if (!isImplementSetupHoursEntered) {
                    this.toastr.error("Please enter the implement setup hours.");
                    break;
                }

                if (this.destEquipment > 0) {
                    var isEquipmentSMUEntered = this.validateEquipmentSMU(implement.equipmentSMUAtSetup);
                    if (!isEquipmentSMUEntered) {
                        this.toastr.error("Please enter the equipment SMU at setup.");
                    }
                }

                this.validateAndCopyImplement(implement);
            }
        }
    }

    validateAndCopyImplement(c) {
        //console.log(c);
        var setupDateParts: string;
        if (c.setupDate != null) {
            setupDateParts = c.setupDate.getDate() + "/" + (c.setupDate.getMonth() + 1) + "/" + c.setupDate.getFullYear();
        } else {
            c.status = 0;
        }
        //console.log(setupDateParts);

        // Validate the serial number first and check that it is not being used elsewhere.
        this._implementService.ValidateImplementSerial(0, c.newSerialNo).subscribe(r => {
            if (!r) {
                this.toastr.error(this.pageErrors.ERROR_SERIALNO_VALIDATION_FAILED);
                c.newSerialNo = "";
                c.status = 0;
            } else {
                // Only process if both the existing implement and serial number are entered.
                if (c.selectImplement && c.implementId > 0 && c.setupDate != null && c.newSerialNo.length > 0) {
                    this._implementService.CreateCopyBasedOnExistingImplement(c.implementId, c.newSerialNo, this.destEquipment, this.destJobsite,
                        setupDateParts, c.implementHoursAtSetup, c.equipmentSMUAtSetup,0,false//budget life
                        ).subscribe(r2 => {

                            if (r2) {
                                c.status = 1;
                                c.selectImplement = false;

                                var params1 = this.createImplementDetailParams();
                                params1.Details.Id = c.implementId;
                                params1.Details.ImplementHoursAtSetup = c.implementHoursAtSetup;
                                params1.Details.SetupDate = setupDateParts;

                                this._implementService.CreateImplementSetupEvent(params1).subscribe(r => {
                                    if (r < 0) {
                                        this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
                                    }
                                });

                            } else {
                                this.toastr.error(this.pageErrors.ERROR_SAVING_SETUP_EVENT);
                                c.status = -1;
                            }
                        });
                } else {
                    this.toastr.error(this.pageErrors.ERROR_SAVING_CHANGES);
                    c.status = 0;
                }
            }
        });
    }

    createImplementDetailParams(): SaveImplementDetailParams {
        var details: ImplementDetails = new ImplementDetails();
        details.Id = 0;
        details.ImplementType = 0;
        details.Make = 0;
        details.SerialNo = "";
        details.SetupDate = "";
        details.ImplementHoursAtSetup = 0;
        details.EquipmentSMUAtSetup = 0;

        var params = new SaveImplementDetailParams();
        params.Details = details;
        params.EquipmentId = this.selectedEquipment;
        params.JobsiteId = this.selectedJobsite;

        return params;
    }
}
